const updateNavbarCta = () => {
	const isSmall = window.matchMedia('(max-width: 392px)').matches;
	const isMobile = window.matchMedia('(max-width: 768px)').matches;

	const applyMobileFontSize = (el) => {
		const target = el.querySelector('button') ?? el;
		const textLength = target.textContent.trim().length;

		if (isMobile && textLength >= 9) {
			target.style.fontSize = '15px';
		} else {
			target.style.removeProperty('font-size');
		}
	};

	document.querySelectorAll('[data-navbar-cta-mobile]').forEach((el) => {
		el.classList.toggle('hidden', !isSmall);
		el.classList.toggle('block', isSmall);
	});

	document.querySelectorAll('[data-navbar-cta-desktop]').forEach((el) => {
		el.classList.toggle('hidden', isSmall);
		applyMobileFontSize(el);
	});
};

updateNavbarCta();
window.addEventListener('resize', updateNavbarCta);
